import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import { setLogin } from "../../state";
import { tokens } from "../../theme";

const Login = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  let urlSaccWeb = process.env.REACT_APP_URL_SACCWEB;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    try {
      const response = await axios.post(urlSaccWeb + "auth/", {
        username,
        password,
      });
      if (response.data.estaAutenticado) {
        dispatch(setLogin({ user: username, token: response.data.token }));
        navigate("/home");
      } else {
        setError("Credenciales inválidas.");
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Error de red o del servidor.");
    }
  };

  const inputSx = {
    "& .MuiInputBase-root": {
      backgroundColor: "rgba(255,255,255,0.08)",
      borderRadius: 1,
    },
    "& .MuiInputBase-input": { color: "#fff" },
    "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.7)" },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255,255,255,0.3)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255,255,255,0.6)",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#fff",
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#fff" },
  };

  return (
    <Grid
      container
      component="main"
      sx={{
        height: "100vh",
        backgroundImage: "url(img/banner.webp)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Left dark overlay panel */}
      <Grid
        item
        xs={false}
        sm={7}
        sx={{ backgroundColor: "rgba(0,0,0,0.25)" }}
      />

      {/* Right glassmorphism panel */}
      <Grid
        item
        xs={12}
        sm={5}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255,255,255,0.12)",
          backdropFilter: "blur(18px)",
          WebkitBackdropFilter: "blur(18px)",
          borderLeft: "1px solid rgba(255,255,255,0.2)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 400,
            px: 4,
            py: 6,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box mb={3}>
            <img
              alt="logo CONATEL"
              src="img/logoCnt.jpg"
              style={{ maxWidth: 360, width: "100%" }}
            />
          </Box>

          <Typography
            component="h1"
            variant="h5"
            sx={{ color: "#fff", mb: 3, fontWeight: 600, letterSpacing: 1 }}
          >
            Iniciar Sesión
          </Typography>

          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ width: "100%" }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="user"
              label="Usuario"
              name="user"
              autoComplete="username"
              autoFocus
              onChange={(e) => setUsername(e.target.value)}
              sx={inputSx}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
              sx={inputSx}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                py: 1.2,
                backgroundColor: "rgba(255,255,255,0.2)",
                color: "#fff",
                fontWeight: 700,
                letterSpacing: 1,
                border: "1px solid rgba(255,255,255,0.4)",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.32)" },
              }}
            >
              Ingresar
            </Button>

            {error && (
              <Alert severity="error" sx={{ mb: 1 }}>
                {error}
              </Alert>
            )}

            <Typography
              variant="body2"
              align="center"
              sx={{ color: "rgba(255,255,255,0.65)", mt: 4 }}
            >
              Comisión Nacional de Telecomunicaciones CONATEL
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Login;
